import { useEffect } from 'react'

import { AppConfig, PlanNetworkMap } from 'src/api/types'
import { TServiceLine } from 'src/shared/types'

interface StoreData {
  networks?: string[]
  planNetworkMaps?: PlanNetworkMap[]
  serviceLines?: {
    doctor: TServiceLine[]
    facility: TServiceLine[]
  }
  appConfig?: AppConfig
  selectedPlan?: string
}

export const setStore = (value: StoreData) => {
  const data = JSON.stringify(value)

  localStorage.setItem('globalStore', data)
}

export const getStore = (): StoreData | null => {
  const data = localStorage.getItem('globalStore')

  return data ? (JSON.parse(data) as StoreData) : null
}

export const usePersistStore = (value: StoreData) => {
  useEffect(() => () => setStore(value), [value])
}
